import BaseClass from "../../libs/base/BaseClass";
import gsap from "gsap";
import RippleManagerClass from "../common/RippleManagerClass";

export default class PlaneTicketItemDetails extends BaseClass {
    constructor(_key,_target) {
        super();
        this.key = _key;
        this.target = _target;

        this.EVENT_OPEN = "eventOpen";
        this.CL_OPEN = "isOpen";

        this.tween = [];
        this.ease = "power3.out";
        this.duration = 0.3;

        this.isOpen = false;
    }

    onCreate() {
        super.onCreate();

        this.ripple = new RippleManagerClass(this.target);
        this.ripple.onCreate();

        this.summy = $(`.${this.key}__item__summary`,this.target);
        this.mask = $(`.${this.key}__item__mask`,this.target);
        this.body = $(`.${this.key}__item__body`,this.target);

        this.summy.on("click",this.onClick.bind(this));
    }

    onRemove() {
        super.onRemove();

        if(this.ripple){
            this.ripple.onRemove();
            this.ripple = null;
        }

        this.summy.off("click",this.onClick.bind(this));

        for(let k in this.tween){
            this.tween[k].kill();
            this.tween[k] = null;
        }
        this.tween = [];
        delete this.tween;

        this.summy = null;
        this.mask = null;
        this.body = null;
    }

    onClick(e){
        e.preventDefault();

        for(let k in this.tween){
            this.tween[k].kill();
            this.tween[k] = null;
        }
        this.tween = [];

        const open = !this.isOpen;
        if(open){
            this.onOpen();
        } else {
            this.onClose();
        }

        this.isOpen = open;
    }

    onOpen(){
        this.jq.trigger(this.EVENT_OPEN);
        this.target.attr({open:true});

        this.summy.addClass(this.CL_OPEN);
        const h = this.body.outerHeight();
        this.tween.push(gsap.to(this.mask,{height:h,duration:this.duration,ease:this.ease,onComplete:()=>{
                this.mask.css({height:"auto"});
                $(window).trigger("resize");
            }
        }));
    }
    onOpenBefore(){}
    onOpenAfter(){}

    onClose(_callback){

        this.summy.removeClass(this.CL_OPEN);
        this.tween.push(gsap.to(this.mask,{height:0,duration:this.duration,ease:this.ease,onComplete:()=>{
                this.target.removeAttr("open");
                $(window).trigger("resize");
                if(_callback) _callback();
            }
        }));
    }
}